export var CommunityReviewerOnboardingStep;
(function (CommunityReviewerOnboardingStep) {
    CommunityReviewerOnboardingStep["HasCheckedClipReview"] = "hasCheckedClipReview";
})(CommunityReviewerOnboardingStep || (CommunityReviewerOnboardingStep = {}));
export var CreatorOnboardingStep;
(function (CreatorOnboardingStep) {
    CreatorOnboardingStep["HasFoundDrop"] = "hasFoundDrop";
    CreatorOnboardingStep["HasCheckedRewards"] = "hasCheckedRewards";
})(CreatorOnboardingStep || (CreatorOnboardingStep = {}));
export var OnboardingStateType;
(function (OnboardingStateType) {
    OnboardingStateType["CommunityReviewer"] = "communityReviewer";
    OnboardingStateType["Creator"] = "creator";
})(OnboardingStateType || (OnboardingStateType = {}));
